package com.oasisfeng.invaluable.p2p.webrtc

/**
 * Abstracts platform-specific DataChannel API differences between browser WebRTC and node-datachannel.
 */
interface DataChannelAdapter {
    fun isOpen(dc: dynamic): Boolean
    fun send(dc: dynamic, message: String)
    fun bindEvents(dc: dynamic, onOpen: () -> Unit, onMessage: (String) -> Unit, onClose: () -> Unit)
    fun clearEvents(dc: dynamic)

    companion object {
        /** Browser WebRTC DataChannel adapter. */
        val Browser = object : DataChannelAdapter {
            override fun isOpen(dc: dynamic) = dc.readyState == "open"
            override fun send(dc: dynamic, message: String) { dc.send(message) }
            override fun bindEvents(dc: dynamic, onOpen: () -> Unit, onMessage: (String) -> Unit, onClose: () -> Unit) {
                dc.onopen = { onOpen() }
                dc.onmessage = { event: dynamic -> (event.data as? String)?.let(onMessage) }
                dc.onclose = { onClose() }
                dc.onerror = { _: dynamic -> onClose() }
            }
            override fun clearEvents(dc: dynamic) {
                dc.onopen = null
                dc.onmessage = null
                dc.onclose = null
                dc.onerror = null
            }
        }

        /** node-datachannel DataChannel adapter. */
        val NodeDataChannel = object : DataChannelAdapter {
            override fun isOpen(dc: dynamic) = dc.isOpen() as? Boolean ?: false
            override fun send(dc: dynamic, message: String) { dc.sendMessage(message) }
            override fun bindEvents(dc: dynamic, onOpen: () -> Unit, onMessage: (String) -> Unit, onClose: () -> Unit) {
                dc.onOpen { onOpen() }
                dc.onMessage { msg: dynamic -> (msg as? String)?.let(onMessage) }
                dc.onClosed { onClose() }
                dc.onError { _: dynamic -> onClose() }
            }
            override fun clearEvents(dc: dynamic) {
                runCatching { dc.onOpen(null) }
                runCatching { dc.onMessage(null) }
                runCatching { dc.onClosed(null) }
                runCatching { dc.onError(null) }
            }
        }
    }
}
